export default {
    namespaced: true,
    state: {
        informacion_empresa: [],
        ubicacion: [],
        dato_contacto: [],
        informacion_representante: [],
        informacion_autorizado_legal: [],
        foto_nit: [],
        foto_rnc: [],
        foto_matricula: [],
        foto_nit_persona: [],
        foto_dui_persona: [],
        foto_carnet_persona: [],
        step: 0,
        tab: 1,
        isNITvalid: false,
    },
    mutations: {
        setData(state, payload) {
            state.informacion_empresa = payload.info_empresa
            state.ubicacion = payload.ubicacion
            state.dato_contacto = payload.dato_contacto
            state.informacion_representante = payload.informacion_representante
            state.informacion_autorizado_legal = payload.informacion_autorizado_legal
        },
        setFoto(state, payload) {
            if (payload.fotonit !== null) {
                state.foto_nit = payload.fotonit
            }
        },

        setFotoRnc(state, payload) {
            if (payload.fotornc !== null) {
                state.foto_rnc = payload.fotornc
            }
        },

        setFotoMatricula(state, payload) {
            if (payload.fotomatricula !== null) {
                state.foto_matricula = payload.fotomatricula
            }
        },

        setFotoNit(state, payload) {
            if (payload.fotonitpersona !== null) {
                state.foto_nit_persona = payload.fotonitpersona
            }
        },
        setFotoDui(state, payload) {
            if (payload.fotoduipersona !== null) {
                state.foto_dui_persona = payload.fotoduipersona
            }
        },
        setFotoCarnet(state, payload) {
            if (payload.fotocarnetpersona !== null) {
                state.foto_carnet_persona = payload.fotocarnetpersona
            }
        },
        setStep(state, payload) {
            state.step = payload
        },
        setTab(state, payload) {
            state.tab = payload
        },
        viewIsNITvalid(state, payload) {
            state.isNITvalid = payload
        },
        reiniciarFoto(state, payload) {
            state.foto_nit_persona = []
            state.foto_rnc = []
            state.foto_nit = []
        }
    },
    actions: {
        setData({commit}, payload) {
            payload.tipo == 1 ? window.localStorage.setItem('informacion_empresa', JSON.stringify(payload.info_empresa)) : null
            payload.tipo == 2 ? window.localStorage.setItem('ubicacion', JSON.stringify(payload.ubicacion)) : null
            payload.tipo == 3 ? window.localStorage.setItem('dato_contacto', JSON.stringify(payload.dato_contacto)) : null
            payload.tipo == 4 ? window.localStorage.setItem('informacion_representante', JSON.stringify(payload.informacion_representante)) : null
            payload.tipo == 5 ? window.localStorage.setItem('informacion_autorizado_legal', JSON.stringify(payload.informacion_autorizado_legal)) : null
            commit('setData', payload)
        },
        setDataFotos({commit}, payload) {
            payload.tipo == 1 ? commit('setFoto', payload) : null
            payload.tipo == 2 ? commit('setFotoRnc', payload) : null
            payload.tipo == 3 ? commit('setFotoMatricula', payload) : null
            payload.tipo == 4 ? commit('setFotoNit', payload) : null
            payload.tipo == 5 ? commit('setFotoDui', payload) : null
            payload.tipo == 6 ? commit('setFotoCarnet', payload) : null
        },
       reiniciarDataFotos({commit}, payload) {
          commit('reiniciarFoto', payload)
       },

        setInfoEmpresa() {
            let InfoEmpresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
            if (InfoEmpresa) {
                axios.get(process.env.VUE_APP_API_URL + '/api/v1/empresas?nit=' + InfoEmpresa.nit + '&nrc=' + InfoEmpresa.nrc,
                    {
                        headers: {'Content-Type': 'application/json'}
                    }).then((response) => {
                    window.localStorage.setItem('InfoEmpresas', JSON.stringify(response.data[0]))
                })
            }
        },
        setStep({commit}, payload) {
            commit('setStep', payload)
        },
        setTab({commit}, payload) {
            commit('setTab', payload)
        },
        viewIsNITvalid({commit}, payload) {
            let nit = payload
                let valido = false;
            if (nit!==null){
                if (nit.length === 17 || nit.length===14) {
                    if (nit !== '0000-000000-000-0' && nit.match(/^[0-9]{4}-[0-9]{6}-[0-9]{3}-[0-9]$/)) {
                        // Validando que no sea ceros todos los dígitos
                        // Obteniendo los dígitos y el verificador por separado
                        let [ubicacion, fecha, correlativo, validador] = nit.split('-');
                        let digitos = (ubicacion + fecha + correlativo).split('');
                        // Convirtiendo los datos a tipo integer
                        validador = parseInt(validador, 10);
                        correlativo = parseInt(correlativo, 10);
                        let suma = 0;
                        let mod = 0;
                        if (correlativo <= 100) {
                            // Obteniendo la suma corresponiente
                            suma = digitos.reduce((total, digito, index) => {
                                return total += (parseInt(digito, 10) * (14 - index))
                            }, 0);
                            // Obteniendo el Modulo base 11
                            mod = suma % 11;
                            mod = mod === 10 ? 0 : mod;
                        } else {
                            // Obteniendo la suma corresponiente
                            suma = digitos.reduce((total, digito, index) => {
                                return  total += (parseInt(digito, 10) * parseInt((3 + 6 * Math.floor((index + 5) / 6)) - (index + 1), 10))
                            }, 0);
                            mod = suma % 11;
                            // Obteniendo el Modulo base 11
                            mod = mod > 1 ? (11 - mod) : 0;
                        }
                        if (mod === validador) {
                            valido = true;
                            commit('viewIsNITvalid', valido)
                        }else {
                            valido = false;
                            commit('viewIsNITvalid', valido)
                        }
                    }
                }
            }
                return valido;
            }

    },
    getters: {
        gettab: (state) => {
            return state.tab
        },
        getStep: (state) => {
            return state.step
        },
        getFotoNit: (state) => {
            return state.foto_nit
        },
        getFotoRnc: (state) => {
            return state.foto_rnc
        },
        getFotoMatricula: (state) => {
            return state.foto_matricula
        },
        getFotoNitPersona: (state) => {
            return state.foto_nit_persona
        },
        getFotoDuiPersona: (state) => {
          return state.foto_dui_persona
        },
        getFotoCarnetPersona: (state) => {
            return state.foto_carnet_persona
        },
        getLocalStorage_: (state) => {
            let getLocalStorageInformacionEmpresa, getLocalStorageUbicacion, getLocalStorageDatoContacto,
                getLocalStorageAutorizadoLegal, getLocalStorageRepresentante
            getLocalStorageInformacionEmpresa = JSON.parse(window.localStorage.getItem('informacion_empresa'))
            getLocalStorageUbicacion = JSON.parse(window.localStorage.getItem('ubicacion'))
            getLocalStorageDatoContacto = JSON.parse(window.localStorage.getItem('dato_contacto'))
            getLocalStorageAutorizadoLegal = JSON.parse(window.localStorage.getItem('informacion_autorizado_legal'))
            getLocalStorageRepresentante = JSON.parse(window.localStorage.getItem('informacion_representante'))
            if (getLocalStorageInformacionEmpresa) {
                state.informacion_empresa = getLocalStorageInformacionEmpresa
            }
            if (getLocalStorageUbicacion) {
                state.ubicacion = getLocalStorageUbicacion
            }
            if (getLocalStorageDatoContacto) {
                state.dato_contacto = getLocalStorageDatoContacto
            }
            if (getLocalStorageAutorizadoLegal) {
                state.informacion_autorizado_legal = getLocalStorageAutorizadoLegal
            }
            if (getLocalStorageRepresentante) {
                state.informacion_representante = getLocalStorageRepresentante
            }
            let DatosFormulario = {
                'informacion_empresa': state.informacion_empresa,
                'ubicacion': state.ubicacion,
                'dato_contacto': state.dato_contacto,
                'informacion_representante': state.informacion_representante,
                'informacion_autorizado_legal': state.informacion_autorizado_legal
            }
            return DatosFormulario
        },

        getInfoEmpresa({commit}, payload) {
        },
        getIsNitValid:(state) => {
            return state.isNITvalid
        },
    }
}
